window.FunSidebar = new function()
{
    this.init = function() {
        jQuery('body').on('click', '.account-sidebar-toggle', function() {
            FunSidebar.accountSidebarToggle();
        });

        jQuery('body').on('click', '.account-sidebar-close', function() {
            FunSidebar.accountSidebarToggle();
        });

        jQuery('body').on('click', '.left-sidebar-toggle', function() {
            if(jQuery('body').hasClass('right-sidebar-open')) {
                FunSidebar.closeRightSidebars();
            }

            FunSidebar.leftSidebarToggle();
        });

        jQuery('body').on('click', '.right-sidebar-toggle', function() {
            if(jQuery('body').hasClass('sidebar-open')) {
                FunSidebar.leftSidebarToggle();
            }

            FunSidebar.rightSidebarToggle();
        });

        jQuery('body').on('click', '.right-sidebar-banner-toggle', function() {
            if(jQuery('body').hasClass('sidebar-open')) {
                FunSidebar.leftSidebarToggle();
            }

            FunSidebar.rightSidebarBannerToggle();
        });

        jQuery('body').on('click', '.left-sidebar.visible > .overlay', function() {
            jQuery('.left-sidebar').removeClass('visible');
            jQuery('.mbl-toolbar').removeClass('sidebar-open');
            jQuery('.left-sidebar-toggle').removeClass('sidebar-open');
            jQuery('body').removeClass('sidebar-open');
            jQuery('.left-sidebar .overlay').remove();
        });

        jQuery('body').on('click', '.right-sidebar-hidden.visible > .overlay', function() {
            jQuery('.right-sidebar-hidden').removeClass('visible');
            jQuery('.mbl-toolbar').removeClass('right-sidebar-open');
            jQuery('.right-sidebar-banner-toggle').removeClass('right-sidebar-open');
            jQuery('body').removeClass('right-sidebar-open');
            jQuery('.right-sidebar-hidden .overlay').remove();
        });

        jQuery('body').on('click', '.right-sidebar.visible > .overlay', function() {
            jQuery('.right-sidebar-hidden').removeClass('visible');
            jQuery('.mbl-toolbar').removeClass('right-sidebar-open');
            jQuery('.right-sidebar-banner-toggle').removeClass('right-sidebar-open');
            jQuery('body').removeClass('right-sidebar-open');
            jQuery('.right-sidebar-hidden .overlay').remove();
        });

        var tab_bar_width = jQuery('.right-sidebar .fs-tta .tab-bar').outerWidth();
        var tabs_width    = 0;

        jQuery('.right-sidebar .fs-tta .tab-bar li').each(function(index, el) {
            tabs_width += jQuery(this).outerWidth();
        });

        if(tabs_width > tab_bar_width) {
            jQuery('.right-sidebar .fs-tta .tab-bar').addClass('scroll-list');
        }

        var left_tab_bar_width = jQuery('.left-sidebar .fs-tta .tab-bar').outerWidth();
        var left_tabs_width    = 0;

        jQuery('.left-sidebar .fs-tta .tab-bar li').each(function(index, el) {
            left_tabs_width += jQuery(this).outerWidth();
        });

        if(left_tabs_width > left_tab_bar_width) {
            jQuery('.left-sidebar .fs-tta .tab-bar').addClass('scroll-list');
        }

        jQuery(window).resize( function() {
            tab_bar_width = jQuery('.right-sidebar .fs-tta .tab-bar').outerWidth();
            tabs_width    = 0;

            jQuery('.right-sidebar .fs-tta .tab-bar li').each(function(index, el) {
                tabs_width += jQuery(this).outerWidth();
            });

            if(tabs_width > tab_bar_width) {
                jQuery('.right-sidebar .fs-tta .tab-bar').addClass('scroll-list');
            } else {
                jQuery('.right-sidebar .fs-tta .tab-bar').removeClass('scroll-list');
            }

            left_tab_bar_width = jQuery('.left-sidebar .fs-tta .tab-bar').outerWidth();
            left_tabs_width    = 0;

            jQuery('.left-sidebar .fs-tta .tab-bar li').each(function(index, el) {
                left_tabs_width += jQuery(this).outerWidth();
            });

            if(left_tabs_width > left_tab_bar_width) {
                jQuery('.left-sidebar .fs-tta .tab-bar').addClass('scroll-list');
            } else {
                jQuery('.left-sidebar .fs-tta .tab-bar').removeClass('scroll-list');
            }
        });
    };

    this.accountSidebarToggle = function() {
        if(jQuery('body').hasClass('sidebar-open')) {
            jQuery('.account-sidebar').removeClass('visible');
            jQuery('.account-sidebar-toggle').removeClass('sidebar-open');
            jQuery('body').removeClass('sidebar-open');
            jQuery('.account-sidebar .overlay').remove();
        } else {
            jQuery('.account-sidebar').append('<div class="overlay absolute full"></div>');
            jQuery('.account-sidebar').addClass('visible');
            jQuery('.account-sidebar-toggle').addClass('sidebar-open');
            jQuery('body').addClass('sidebar-open');
        }
    };

    this.leftSidebarToggle = function() {
        if(jQuery('body').hasClass('sidebar-open')) {
            jQuery('.left-sidebar').removeClass('visible');
            jQuery('.mbl-toolbar').removeClass('sidebar-open');
            jQuery('.left-sidebar-toggle').removeClass('sidebar-open');
            jQuery('body').removeClass('sidebar-open');
            jQuery('.left-sidebar .overlay').remove();
        } else {
            jQuery('.left-sidebar').append('<div class="overlay absolute full"></div>');
            jQuery('.left-sidebar').addClass('visible');
            jQuery('.mbl-toolbar').addClass('sidebar-open');
            jQuery('.left-sidebar-toggle').addClass('sidebar-open');
            jQuery('body').addClass('sidebar-open');
        }
    };

    this.rightSidebarToggle = function() {
        if(jQuery('body').hasClass('right-sidebar-open')) {
            FunSidebar.closeRightSidebars();
        } else {
            jQuery('.right-sidebar').append('<div class="overlay absolute full"></div>');
            jQuery('.right-sidebar').addClass('visible');
            jQuery('.mbl-toolbar').addClass('right-sidebar-open');
            jQuery('.right-sidebar-toggle').addClass('right-sidebar-open');
            jQuery('body').addClass('right-sidebar-open');
            jQuery('.right-sidebar .accordion .accordion-title').addClass('open');
            jQuery('.right-sidebar .accordion .accordion-body').css('display', '');
        }
    };

    this.rightSidebarBannerToggle = function() {
        if(jQuery('body').hasClass('right-sidebar-open')) {
            FunSidebar.closeRightSidebars();
        } else {
            jQuery('.right-sidebar-hidden').append('<div class="overlay absolute full"></div>');
            jQuery('.right-sidebar-hidden').addClass('visible');
            jQuery('.mbl-toolbar').addClass('right-sidebar-open');
            jQuery('.right-sidebar-banner-toggle').addClass('right-sidebar-open');
            jQuery('body').addClass('right-sidebar-open');
            jQuery('.right-sidebar .accordion .accordion-title').addClass('open');
            jQuery('.right-sidebar .accordion .accordion-body').css('display', '');
        }
    };

    this.closeRightSidebars = function() {
        jQuery('.right-sidebar > .overlay').remove();
        jQuery('.right-sidebar').removeClass('visible');
        jQuery('.mbl-toolbar').removeClass('right-sidebar-open');
        jQuery('.right-sidebar-toggle').removeClass('right-sidebar-open');
        jQuery('body').removeClass('right-sidebar-open');

        jQuery('.right-sidebar-hidden > .overlay').remove();
        jQuery('.right-sidebar-hidden').removeClass('visible');
        jQuery('.right-sidebar-banner-toggle').removeClass('right-sidebar-open');
    };
}

jQuery(document).ready(function($) {
    FunSidebar.init();
});
